export const generateSessionId = () =>
  [...Array(30)].map(() => Math.random().toString(36)[2]).join("");

export const saveNewSessionId = (where = null) => {
  const newSessionId = generateSessionId();
  sessionStorage.setItem("sessionId", newSessionId);
  where;
  return newSessionId;
};

export const getCurrentSessionId = () => sessionStorage.getItem("sessionId");
